import { Timestamp } from "firebase/firestore";
import moment, { Moment } from "moment";
import serializable, { propretyCustomSerializable } from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";

@serializable
export class Customer extends EntityFirebase {
  @propretyCustomSerializable((value: Moment) => Timestamp.fromDate(value.toDate()))
  private createdAt: Moment;

  @propretyCustomSerializable((value: Moment) => Timestamp.fromDate(value.toDate()))
  private updatedAt: Moment;

  constructor(
    public readonly id: string,
    private name: string,
    private phone: string = "",
    private notes: string = "",
    createdAt: Moment = moment(),
    updatedAt: Moment = moment()
  ) {
    super();
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  getName() {
    return this.name;
  }

  setName(name: string) {
    this.name = name;
    this.touch();
  }

  getPhone() {
    return this.phone;
  }

  setPhone(phone: string) {
    this.phone = phone;
    this.touch();
  }

  getNotes() {
    return this.notes;
  }

  setNotes(notes: string) {
    this.notes = notes;
    this.touch();
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getUpdatedAt() {
    return this.updatedAt;
  }

  touch() {
    this.updatedAt = moment();
  }

  static async build(id: string, data: any) {
    return new this(
      id,
      data.name || "",
      data.phone || "",
      data.notes || "",
      data.createdAt ? moment(data.createdAt.toDate()) : moment(),
      data.updatedAt ? moment(data.updatedAt.toDate()) : moment()
    );
  }
}
